const headerStyle = () => {
    if($('.module--page-head').length) {
        if ($(window).width() > 992) {
            if( $(window).scrollTop() > 350 ) {
                $('.header').addClass('header--fixed');
                $('.collapse__close, .modal__close').css('top', '25px');
            } else {
                $('.header').removeClass('header--fixed');
                $('.collapse__close, .modal__close').css('top', '55px');
            }
        }else{
            if( $(window).scrollTop() > 50 ) {
                $('.header').addClass('header--fixed');
                $('.collapse__close, .modal__close').css('top', '25px');
            } else {
                $('.header').removeClass('header--fixed');
                $('.collapse__close, .modal__close').css('top', '55px');
            }
        }
    }else {
        $('.header').addClass('header--fixed');
        $('.collapse__close, .modal__close').css('top', '25px');
    }
}

$(document).on('scroll', function(){
    // to prevent you from seeing some shocks when loading the page, the transition is only applied if header--fixed is activated
    $('.header').css('transition', 'all 0.4s');
    $('.header__content__brand__img').css('transition', 'all 0.4s');
    headerStyle();
})

$( document ).ready(function() {
    headerStyle();
})
